export const jsonCustomAbiertas = [
  {
    tipo: 1,
    nombre: 'textarea',
    json: {
      answers: [
        {
          type: 2,
          isTextArea: true,
          isOnlyNumeric: false,
          length: 500
        }
      ]
    }
  },
  {
    tipo: 2,
    nombre: 'inputNumerico',
    json: {
      answers: [
        {
          type: 2,
          isTextArea: false,
          isOnlyNumeric: true,
          length: 500
        }
      ]
    }
  },
];

export const idiomasEncuesta = [
  {
    idLanguage: 1,
    iso: "en-US",
    abbr: "en",
    name: "English",
    text: "English",
    flag: "English.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 2,
    iso: "es-ES",
    abbr: "es",
    name: "Español",
    text: "Español",
    flag: "Spanish.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 3,
    iso: "tu-TU",
    abbr: "tr",
    name: "Turkey",
    text: "Türkçe",
    flag: "Turkey.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 4,
    iso: "ar-AR",
    abbr: "ar",
    name: "Arabic",
    text: "عرب",
    flag: "Arabic.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 5,
    iso: "zh-ZH",
    abbr: "zh",
    name: "Chinese",
    text: "中文",
    flag: "Chinese.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 6,
    iso: "vi-VI",
    abbr: "vi",
    name: "Vietnamese",
    text: "Vietnamese",
    flag: "Vietnamense.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 7,
    iso: "ro-RO",
    abbr: "ru",
    name: "Romanian",
    text: "Romanian",
    flag: "Romanian.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 8,
    iso: "zh1-ZH1",
    abbr: "zh1",
    name: "繁體中文",
    text: "繁體中文",
    flag: "????.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 9,
    iso: "zh2-ZH2",
    abbr: "zh2",
    name: "简体中文",
    text: "简体中文",
    flag: "????.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 10,
    iso: "my-MY",
    abbr: "my",
    name: "Melayu",
    text: "Melayu",
    flag: "Melayu.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 11,
    iso: "pt-PT",
    abbr: "pt",
    name: "Portugues",
    text: "Português",
    flag: "Portuguese.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 12,
    iso: "ge-GE",
    abbr: "ge",
    name: "German",
    text: "Deutsch",
    flag: "Aleman.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 13,
    iso: "bg-BG",
    abbr: "bg",
    name: "Български",
    text: "Български",
    flag: "Bulgarian.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 14,
    iso: "fr-FR",
    abbr: "fr",
    name: "French",
    text: "Français",
    flag: "French.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 15,
    iso: "de-DE",
    abbr: "de",
    name: "German",
    text: "Deutsch",
    flag: "German.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 16,
    iso: "it-IT",
    abbr: "it",
    name: "Italian",
    text: "Italiano",
    flag: "Italian.ico",
    dateCreate: null,
    dateUpdate: null
  },
  {
    idLanguage: 17,
    iso: "nl-NL",
    abbr: "nl",
    name: "Dutch",
    text: "Nederlands",
    flag: "Dutch.ico",
    dateCreate: null,
    dateUpdate: null
  }
];
